import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Save, RotateCcw } from "lucide-react";
import { adminApi, AdminHeader } from "@/lib/adminApi";

const AdminVoice = () => {
  const [text, setText] = useState("");
  const [def, setDef] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    adminApi("/admin/voice-profile").then((d) => { setText(d.text); setDef(d.default); }).catch((e) => toast.error(e.message));
  }, []);

  const save = async () => {
    setSaving(true);
    try { await adminApi("/admin/voice-profile", { method: "PUT", body: { text } }); toast.success("Voice profile saved"); }
    catch (e) { toast.error(e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-4xl">
      <AdminHeader title="Raulvin Voice Profile" subtitle="Guides every AI-repurposed LinkedIn post, X thread and YouTube script" testId="voice-heading">
        <div className="flex gap-2">
          <button onClick={() => setText(def)} className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="voice-reset-btn"><RotateCcw className="w-4 h-4" /> Reset to default</button>
          <button onClick={save} disabled={saving} className="flex items-center gap-1.5 bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors disabled:opacity-60" data-testid="voice-save-btn"><Save className="w-4 h-4" /> Save</button>
        </div>
      </AdminHeader>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={24} className="w-full bg-[var(--bg-card)] border-glow rounded-xl p-5 text-sm text-white leading-relaxed font-mono resize-y focus:outline-none focus:border-[var(--accent-violet)]" data-testid="voice-textarea" />
    </div>
  );
};

export default AdminVoice;
